import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, ListGroup, Alert, Button } from 'react-bootstrap';

// Domains known to support iframe embedding
export const EMBEDDABLE_HOSTS = ['dailymotion.com', 'geo.dailymotion.com', 'ok.ru', 'bysesukior.com'];

export function isEmbeddable(url) {
    try {
        const { hostname } = new URL(url);
        return EMBEDDABLE_HOSTS.includes(hostname);
    } catch {
        return false;
    }
}

function NflGame() {
    const { gameId } = useParams();  // Extract gameUrl from the route parameters
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const navigate = useNavigate();  // Initialize useNavigate to programmatically navigate

    const [videoUrls, setVideoUrls] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);  // To store the currently selected video URL
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch the video URLs for the specific game from the backend
        fetch(`${baseUrl}/streaming/nfl/event/video/${gameId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();  // Assuming the API returns a JSON response
            })
            .then(data => setVideoUrls(data.videoUrls))  // Update with the videoUrls array
            .catch(err => {
                setError(err.message);
            });
    }, [baseUrl, gameId]);

    const handleVideoClick = (videoUrl) => {
        setSelectedVideo(videoUrl.startsWith("//") ? `https:${videoUrl}` : videoUrl);  // Prepend https: to protocol-relative URLs
    };

    const handleBackClick = () => {
        navigate('/streaming/nfl');  // Navigate back to the NFL listing page
    };

    return (
        <Container className="brand-page mt-5">
            <h1>NFL Game Videos</h1>

            {/* Display error if fetching fails */}
            {error && <Alert variant="danger">Error: {error}</Alert>}

            {/* Display list of video links */}
            {videoUrls.length > 0 ? (
                <>
                    <ListGroup>
                        {videoUrls.map((videoUrl, index) => (
                            <ListGroup.Item
                                key={index}
                                action
                                as="button"
                                type="button"
                                className="stream-video-option"
                                onClick={() => handleVideoClick(videoUrl)}
                            >
                                <h5>Video {index + 1}</h5> {/* Generic title based on index */}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>

                    {/* Spacing of 50px between list and button */}
                    <div className="mt-5 d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleBackClick}>
                            Back to NFL Games
                        </Button>
                    </div>
                </>
            ) : (
                <p>No videos available.</p>
            )}

            {/* Display the selected video */}
            {selectedVideo && (
                <div className="mt-4">
                    {isEmbeddable(selectedVideo) ? (
                        <>
                            <h3>Now Playing:</h3>
                            <iframe
                                src={selectedVideo}
                                title={`NFL Video - ${selectedVideo}`}
                                width="100%"
                                height="500px"
                                className="stream-player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </>
                    ) : (
                        <>
                            <h3>External Stream:</h3>
                            <p>This video is hosted on an external site. Click the button below to open it.</p>
                            <Button variant="primary" as="a" href={selectedVideo} target="_blank" rel="noopener noreferrer">
                                Open Video in New Tab
                            </Button>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default NflGame;
